import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient, ApiError } from '../utils/apiClient';

function ForgotPasswordForm() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  const handleForgotPassword = async (event) => {
    event.preventDefault();

    try {
      await apiClient.post('/api/users/forgot-password', { email });
      alert('Password reset instructions have been sent to your email.');
      navigate('/login'); // Redirect to the login page
    } catch (error) {
      console.error('Error sending forgot password request:', error);
      if (error instanceof ApiError) {
        alert('Failed to send password reset instructions. Please try again.');
      } else {
        alert('An error occurred. Please try again.');
      }
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        width: '100vw',
        content: 'center',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      className="NotTheBody"
    >
      <div className="wrapper">
        <form onSubmit={handleForgotPassword}>
          <h1>Forgot Password</h1>
          <div className="input-box">
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button type="submit">Submit</button>
          <div className="register-link">
            <p>
              Remembered your password?{' '}
              <button
                type="button"
                style={{background: 'none', border: 'none', color: 'inherit', textDecoration: 'underline', cursor: 'pointer'}}
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/login'); // Navigate back to the login page
                }}
              >
                Login
              </button>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ForgotPasswordForm;